<template>
  <section class="section Images">
    <div class="modal" :class="{'is-active': flagimageModal}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <form class="new_image">
            <h2>Nueva Imagen</h2>
            <div class="dropzone_content">
              <img v-show="cover" :src="cover" />
              <input
                id="slide"
                style="display: none"
                type="file"
                ref="fileInput"
                @change="onFileChange($event)"
                accept="image/*"
              />
              <label
                class="dropzone"
                for="slide"
                :class="{ready: fileInto}"
                @dragover.prevent="dragover($event)"
                @dragleave.prevent="dragleave($event)"
                @drop.prevent="dragFinish(-1,$event)"
              >
                <div class="open_file" v-if="!file.content">
                  <div class="upload">
                    <ion-icon name="cloud-upload-outline" ></ion-icon>
                  </div>
                  <h1>
                    Arrastrar y soltar imagen o
                    <strong>cargar</strong>
                  </h1>
                </div>
                <div class="file_selected" v-else>
                  <div class="upload">
                    <ion-icon name="image-outline"></ion-icon>
                  </div>
                  <h1>
                    <p>{{file.content.name}}</p>
                    <small>
                      {{(file.content.size / 1000 / 1000).toFixed(2)}} Mb
                      <b v-if="!validateSizeFile">( Archivo muy grande, Max: 20 Mb )</b>
                    </small>
                  </h1>
                </div>
              </label>
            </div>
            <button class="button is-warning is-rounded" :class="{'is-loading': loading}" @click.prevent="uploadPhoto()">Guardar</button>
          </form>
        </div>
      </div>
      <button class="modal-close" aria-label="close" @click="flagimageModal = false">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    <div class="container">
      <div class="level">
        <h1 class="title level-left">Slider</h1>
        <a class="button level-right is-warning is-rounded"  @click="flagimageModal = true" v-if="slideList.length < 3">
          <span class="icon is-small">
            <ion-icon name="add-outline"></ion-icon>
          </span>
          <span>
            Nueva imagen
          </span>
        </a>
      </div>

      <div class="card empty" v-if="!slideList.length">
        <div class="empty_wrapper">
          <img src="@/assets/img/empty_images.svg">
          <p> Todavia no hay imagenes </p>
        </div>
      </div>
      <div v-else  class="card_grid">
        <div class="card" v-for="image in slideList" :key="image.id">
         <img :src="image.url">
          <a class="remove_image" @click="deleteImage(image)">
            <ion-icon name="trash-outline"></ion-icon>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { storage, firestore } from '@/main'
// import moment from 'moment'
export default {
  data: () => ({
    flagimageModal: false,
    slideList: [],
    cover: '',
    file: {
      content: null
    },
    fileInto: false,
    loading: false,
  }),
  mounted() {
    this.getAllimages()
  },
  methods: {
    getAllimages() {
      firestore
        .collection('slide')
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data()
            this.slideList.push({
              id: doc.id,
              url: data.url,
            })
          })
        })
        .catch(console.error)
    },
    deleteImage({id, url}) {
      if ( confirm('¿Seguro que quieres eliminar esta imagen?') ) {
        firestore.collection("slide").doc(id).delete().then(() => {
          const httpsReference = storage.refFromURL(url)
          httpsReference.delete().then(() => {
            this.slideList = this.slideList.filter(i => i.id !== id)
          }).catch((error) => {
            console.error("Error removing document: ", error)
          })
        })
        .catch((error) => {
          console.error("Error removing document: ", error)
        })
      }
    },
    dragFinish (i, e) {
      this.file.content = e.dataTransfer.files[0]
      this.cover = URL.createObjectURL(e.dataTransfer.files[0]);
      this.fileInto = false
    },
    dragover () {
      this.fileInto = true
    },
    dragleave () {
      this.fileInto = false
    },
    onFileChange (e) {
      this.file.content = event.target.files[0];
      this.cover = URL.createObjectURL(e.target.files[0]);
    },
    async uploadPhoto () {
      this.loading = true
      let metadata = { contentType: this.file.type }
      storage.ref('/slide').child(this.uuid()).put(this.file.content, metadata)
        .then(snapshot =>  snapshot.ref.getDownloadURL())
        .then(url => {
          console.log('imagen guardada', url)
          this.storeImage(url)
        })
        .catch(err => {
          console.log(err)
        })
    },
    storeImage (url) {
      firestore.collection("slide").add({
        url
      })
      .then((res) => {
        this.slideList.push({
          id: res.id,
          url: url
        })
        this.flagimageModal = false
        this.clearFiles()
        this.loading = false
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
    },
    clearFiles () {
      this.cover = ''
      this.file = {
        file_type: '0',
        content: null
      }
      this.fileInto = false
    },
    uuid () {
      return 'p_' + Math.random().toString(36).substr(2, 9);
    }
  },
  computed: {
    validateSizeFile () {
      return this.file.content.size / 1000 <= 5000
    },
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../../assets/css/_variables.sass'
.Images
  .empty
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    min-height: 300px
    .empty_wrapper
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      p
        text-align: center
        font-weight: 500
        margin-top: 20px
        font-size: 14px
      img
        width: 150px
        margin-right: -40px
  .card_grid
    display: grid
    grid-template-columns: 1fr 1fr 1fr
    grid-gap: 20px
    .card
      position: relative
      .remove_image
        position: absolute
        right: 10px
        bottom: 10px
        width: 36px
        height: 36px
        border-radius: 50%
        display: flex
        justify-content: center
        align-items: center
        background-color: rgba(black, .5)
        ion-icon
          filter: invert(1)
      img
        display: block
        height: 250px
        width: 100%
        object-fit: cover
  .modal-content
    width: 650px
    .new_image
      padding: 40px
      display: grid
      grid-template-columns: 1fr
      grid-gap: 20px
      .dropzone_content
        width: 100%
        box-sizing: border-box
        position: relative
        .dropzone
          height: 300px
        img
          position: absolute
          left: 0
          top: 0
          width: 100%
          height: 100%
          object-fit: cover
          border-radius: 5px
          width: calc(100% - 30px)
          height: calc(100% - 30px)
          margin: 15px
        .dropzone
          width: 100%
          height: 250px
          background-color: transparent
          border-radius: 5px
          border: 1px dashed darken(#F4F7F8, 10%)
          display: flex
          justify-content: center
          align-items: center
          cursor: pointer
          transition: all ease-in-out .2s
          padding: 20px
          box-sizing: border-box
          position: relative
          z-index: 2
          .open_file, .file_selected
            display: flex
            align-items: center
            background-color: white
            padding: 7px
            padding-right: 25px
            border-radius: 30px
          .file_selected
            small
              font-size: 12px
              font-weight: 400
              margin-top: 2px
              display: block
              b
                color: red
          .upload
            background-color: darken(#F4F7F8, 5%)
            width: 40px
            min-width: 40px
            height: 40px
            border-radius: 50%
            display: flex
            justify-content: center
            align-items: center
            margin-right: 15px
            i
              color: #3273DC
          h1
            font-size: 14px
            font-weight: 500
            p
              line-height: 1.3
              overflow: hidden
              text-overflow: ellipsis
              display: -webkit-box
              -webkit-line-clamp: 1
              -webkit-box-orient: vertical
            strong
              color: #3273DC
          &.ready, &:hover
            background-color: rgba(#F4F7F8, .7)
            border: 1px dashed #3273DC
  .button, .input
    box-sizing: border-box
  h2
    font-weight: 700
  h1
    font-size: 20px
  table
    width: 100%
</style>